import React, { useState } from "react";
import css from "../Data.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useColorList } from "../../../../hooks/color";
import { useSession } from "../../../../hooks/session";
import ColorPalette from "./ColorPalette";
import { useImportSession } from "../../../../hooks/import";

const CustomizeColor = ({ sessionId, layoutFns }) => {
  const { data } = useSession(sessionId);

  const { importSession } = useImportSession();
  const { applyColor } = useColorList();

  const [palette, setPalette] = useState("viridis"),
    [fileContent, setFileContent] = useState(""),
    [sendableForm, setSendableForm] = useState(false),
    [sensitive, setSensitive] = useState(false),
    [iconArrow, setIconArrow] = useState("arrow-alt-circle-right"),
    [sensitiveStyle, setSensitiveStyle] = useState({
      border: "1px solid lightgray",
      pointerEvents: "auto",
    }),
    [inSensitiveStyle, setinSensitiveStyle] = useState({
      border: "2px solid #0c56e0",
      pointerEvents: "none",
    });

  const onToggleClick = () => {
    sensitive === true
      ? setIconArrow("arrow-alt-circle-right")
      : setIconArrow("arrow-alt-circle-left");

    sensitive === true
      ? setSensitiveStyle({
          border: "1px solid lightgray",
          pointerEvents: "auto",
        })
      : setSensitiveStyle({
          border: "2px solid #2385e0",
          pointerEvents: "none",
        });

    sensitive === true
      ? setinSensitiveStyle({
          border: "2px solid #2385e0",
          pointerEvents: "none",
        })
      : setinSensitiveStyle({
          border: "1px solid lightgray",
          pointerEvents: "auto",
        });

    setSensitive(!sensitive);
  };

  const uploadColorList = (e) => {
    const uploadedFile = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      try {
        setFileContent(fileReader.result);
        setSendableForm(true);
      } catch (e) {
        setSendableForm(false);
        setFileContent("");
      }
    };

    if (uploadedFile !== undefined) fileReader.readAsText(uploadedFile);
  };

  const onSubmitColorForm = () => {
    if (sendableForm) {
      const payload = {
        caseSensitive: sensitive,
        fileContent: fileContent,
        palette: palette,
        pathway_internal_id: data.pathwayInternalId,
        protein_type: data.protein_type,
        network_type: data.network_type,
        position: getPositions(layoutFns.getCyElements()),
      };
      applyColor(payload);
    } else {
      alert(
        "itGraph Message:\nTo perform this request, you have to upload a JSON file."
      );
    }
  };

  const resetColors = () => {
    if (data.userColorImported) {
      const payload = getDefaultNetwork(data, layoutFns.getCyElements());
      importSession(payload);
    }
  };

  return (
    <div className={css.customizeColor}>
      <h2 className={css.customizeColorTitle}>Customize Colors</h2>
      <div className={css.customizeColorContainer}>
        <div className={css.customizeColorDescription}>
          <p style={{ color: "grey", lineHeight: "1.3" }}>
            Upload a <strong>tab</strong> file composed of two columns (with the header) 
            containing the current label of the nodes and the numeric value, respectively. 
            If specific label matching is needed, change to "Sensitive" in the following toggle.
            <br />
            Default: "Insensitive" (ignoring upper case letters).
          </p>
        </div>
        <ColorPalette palette={palette} setPalette={setPalette} />
        <div className={css.caseToggleContainer}>
          <div
            className={css.caseSensitive}
            style={sensitiveStyle}
            onClick={onToggleClick}
          >
            Sensitive
          </div>
          <FontAwesomeIcon
            icon={iconArrow}
            size="lg"
            title="How to read the gene list: case sensitive or insensitve."
            className={css.caseToggleIcon}
            onClick={onToggleClick}
          />

          <div
            className={css.caseInsensitive}
            style={inSensitiveStyle}
            onClick={onToggleClick}
          >
            Insensitive
          </div>
        </div>
        <form
          className={css.geneListContainer}
          onSubmit={(event) => {
            event.preventDefault();
            onSubmitColorForm();
          }}
        >
          <label style={{ placeSelf: "center" }}>
            <strong>Upload TSV file:</strong>
          </label>
          <input
            type="file"
            name="filename"
            onChange={uploadColorList}
            style={{ placeSelf: "center" }}
          />
          <div className={css.buttonsColorForm}>
            <button type="submit" className={css.applyColorButton}>
              Apply
            </button>
            <button
              type="button"
              className={css.resetColorsButton}
              onClick={resetColors}
            >
              Reset Colors
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomizeColor;

const getPositions = (cyElements) => {
  let position = {};
  for (let i = 0; i < cyElements.length; i++) {
    if (cyElements[i].group === "nodes") {
      position[cyElements[i].data.id] = {
        position: cyElements[i].position,
        label: cyElements[i].data.label,
      };
    }
  }

  return position;
};

const getDefaultNetwork = (data, cyElements) => {
  return {
    pathway_internal_id: data.pathwayInternalId,
    protein_type: data.protein_type,
    network_type: data.network_type,
    user_position: getPositions(cyElements),
    user_color: {},
  };
};
